import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.213 3.266a.92.92 0 0 0-.866.017L9.715 4.752l7.186 3.646 3.06-1.708zm1.748 6.215L7.776 5.835 3.882 8.008l7.186 3.646zm-4.794 3.782L1.505 8.868a.922.922 0 0 1-.033-1.626l9.977-5.568a2.77 2.77 0 0 1 2.598-.052L22.34 5.83a.922.922 0 0 1 .032 1.627l-4.528 2.527v3.645a.922.922 0 0 1-1.843 0v-2.616l-3.99 2.227v7.132l8.543-5.135a.92.92 0 0 0 .447-.79v-4.074a.922.922 0 0 1 1.843 0v4.074c0 .97-.509 1.87-1.34 2.37l-9.94 5.974a.92.92 0 0 1-.924.015l-8.222-4.59A2.77 2.77 0 0 1 1 15.803v-4.035a.922.922 0 1 1 1.843 0v4.035c0 .334.18.642.473.804l6.85 3.824z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const v = { render: t };
export {
  v as default,
  t as render
};
//# sourceMappingURL=ic_package-DHy5cW1d.js.map
